import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { LoginService } from "src/app/core/login/login.service";
import { LearnerService } from "src/app/core/services/learner.service";
import { LoaderService } from "src/app/core/services/loader.service";
import { ESeparationService } from "src/app/core/services/e-separation.service";
import { SidebarService } from 'src/app/core/services/sidebar.service';

@Component({
  selector: "app-e-separation",
  templateUrl: "./e-separation.component.html",
  styleUrls: ["./e-separation.component.css"],
})
export class ESeparationComponent implements OnInit {
  sidebarCollapsed: boolean = false;
  searchQuery: string = '';
  user: any;
  lndUserType: any;
  name: any;
  emp: any;
  id: any;
  teamData: any;
  whatsappNo !: number;
  personalEmail: any;
  exitReason: any;
  empData: any;
  isHrManager: boolean = false;
  isFinalHrManager: boolean = false;
  isManager: boolean = false;
  isCeo: boolean = false;
  calculatedExitDate: any;
  resignationDate: any;
  proposedDate: string = "";
  comingProposedDate: string = "";
  originalResignationDate: any;
  originalProposedDate: any;
  mailAttachmentEnabled: boolean = false;
  mailAttachmentFile: File | null = null;
  isUploadingAttachment: boolean = false;
  hrRemarksFileUrl: string = '';
  hrRemarksUploadError: string = '';
  hrRemark: string = '';
  hrRemarkRequired: boolean = false;
  ceoRemark: string = '';

  exitFormId !: number;
  promotionData: any;
  empSeparation: any;
  canEditDate: boolean = true;
  renderPromotion: boolean = false;
  showRemarkDiv: boolean = false;
  remark: string = '';
  showNoRecordsAvailable: boolean = false;
  leaveAdjustment: string = 'NA';
  selectedUser: any = null;
  approvalTypes: { [key: string]: string } = {}; 
  approvalType: any = "NA";
  ceoApprovalType: any = 'NA';
  approvalFlowData: any[] = [];
  approvalLevelMap = new Map<number, string>();
  filteredTeamData: any[] = [];


  constructor(
    private learnerService: LearnerService,
    private loginService: LoginService,
    public loaderService: LoaderService,
    private dialog: MatDialog,
    private eSeparationService: ESeparationService,
    private sidebarService: SidebarService
  ) { }

  ngOnInit() {
    this.sidebarService.collapsed$.subscribe(collapsed => {
      this.sidebarCollapsed = collapsed;
    });

    this.learnerService.getUserType().subscribe(
      (res: any) => {
        this.user = res["lnd_user_type"];
        this.lndUserType = true;
        localStorage.setItem("user_type", res["lnd_user_type"]);
      },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );

    this.learnerService.getEmployeeDetails().subscribe(
      (res: any) => {
        this.emp = res.data;
        this.name = res.data.name;
        this.id = res.data.emp_id;
      },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );

    this.eSeparationService.getTeamSeperation().subscribe(
      (res: any) => {
        console.log(res);
        this.approvalFlowData = res?.meta?.approval_flow_data || [];
        this.approvalLevelMap.clear();
        this.approvalFlowData.forEach((level: any) => {
          const order = Number(level?.approver_level);
          const roleName = level?.role_name ? String(level.role_name) : "";
          if (!Number.isNaN(order) && roleName) {
            this.approvalLevelMap.set(order, roleName);
          }
        });
        this.teamData = Array.isArray(res.data) ? res.data : [];
        this.applySearchFilter();
      },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );
  }

  onSearchInput(searchTerm: string): void {
    this.searchQuery = searchTerm;
    this.applySearchFilter();
  }

  applySearchFilter(): void {
    if (!this.teamData || this.teamData.length === 0) {
      this.filteredTeamData = [];
      this.showNoRecordsAvailable = true;
      return;
    }

    const search = (this.searchQuery || '').trim().toLowerCase();
    if (!search) {
      this.filteredTeamData = [...this.teamData];
      this.showNoRecordsAvailable = false;
      return;
    }

    this.filteredTeamData = this.teamData.filter((item: any) => {
      const employeeName = (item?.employee_name || '').toString().toLowerCase();
      const designation = (item?.designation || '').toString().toLowerCase();
      const manager = (item?.manager || '').toString().toLowerCase();
      const joiningDate = (item?.doj || '').toString().toLowerCase();
      const exitDate = (item?.exit_date || '').toString().toLowerCase();
      const status = (item?.current_status || '').toString().toLowerCase();
      const approvalLevel = (item?.current_approval_level || '').toString().toLowerCase();

      return (
        employeeName.includes(search) ||
        designation.includes(search) ||
        manager.includes(search) ||
        joiningDate.includes(search) ||
        exitDate.includes(search) ||
        status.includes(search) ||
        approvalLevel.includes(search)
      );
    });

    this.showNoRecordsAvailable = this.filteredTeamData.length === 0;
  }

  checkExitForms() {
    this.showNoRecordsAvailable = !this.filteredTeamData || this.filteredTeamData.length === 0;
  }

  submitFormAcknowledge(status: string): boolean {
    const data = new FormData();
    data.append('proposed_date', this.comingProposedDate ? this.comingProposedDate : this.calculatedExitDate);
    data.append('leave_adjustment', this.approvalType);
    data.append('remark', this.remark || '');
    data.append('hr_remark', this.hrRemark || '');
    data.append('resignation_date', this.resignationDate || '');
    data.append('exit_form_id', String(this.exitFormId));
    data.append('status', status);

    if (this.isCeo) {
      data.append('ceo_leave_adjustment', this.ceoApprovalType);
      data.append('ceo_remark', this.ceoRemark || '');
    }

    if (this.showRemarkDiv) {
      if (this.isHrManager && !this.isApprovalCheckedValue(this.approvalType)) {
        alert("Please select EL Leave Adjustment.");
        return false; 
      }

      if (this.isManager && !this.remark?.trim()) {
        alert("Please fill Manager Remark.");
        return false; 
      }
    }

    // If CEO is acting: only require CEO remark when they have selected a CEO EL option.
    if (this.isCeo && this.isApprovalCheckedValue(this.ceoApprovalType) && !this.ceoRemark?.trim()) {
      alert("Please fill CEO Remark.");
      return false;
    }

    if (this.isHrManager && !this.hrRemark?.trim()) {
      if (this.hrRemarkRequired) {
        alert("Please fill HR Remark.");
        return false;
      }
    }

    if (this.isHrManager && this.mailAttachmentEnabled && !this.hrRemarksFileUrl) {
      alert("Please upload HR Attachment.");
      return false;
    }

    this.eSeparationService.acknowledgeForm(data).subscribe({
      next: (response: any) => {
        console.log("Response:", response);
        if (response && response.status === true) {
          window.location.reload();
          return true;
        } else {
          alert(response.message || "An error occurred.");
          return false;
        }
      },
      error: (error: any) => {
        console.error("Error:", error);
        const data = error?.error?.data || error?.data || "An unexpected error occurred.";
        alert(data);
        return false;
      },
    });

    return true; 
  }




  onDateChange(event: any): void {

    this.proposedDate = event;
    this.comingProposedDate = event;
    if (event !== this.calculatedExitDate) {

      this.showRemarkDiv = true;
    } else {

      this.showRemarkDiv = false;
    }
    
  }

  onResignationDateChange(event: any): void {
    this.resignationDate = event;
    if (this.isHrManager) {
      this.updateHrChangeState();
    } else {
      this.mailAttachmentEnabled = false;
    }
  }
  onProposedDateChange(event: any): void {
    this.proposedDate = event;
    this.comingProposedDate = event;
    if (event !== this.calculatedExitDate) {
      this.showRemarkDiv = true;
    } else {
      this.showRemarkDiv = false;
    }
    this.updateHrChangeState();
  }

  resetFormProperties() {
    this.remark = '';
    this.proposedDate = '';
    this.leaveAdjustment = '';
    this.showRemarkDiv = false;
    this.hrRemark = '';
    this.ceoRemark = '';
    this.ceoApprovalType = 'NA';
    this.mailAttachmentFile = null;
    this.mailAttachmentEnabled = false;
    this.hrRemarksFileUrl = '';
    this.hrRemarksUploadError = '';
    this.originalResignationDate = undefined;
    this.originalProposedDate = undefined;
    this.hrRemarkRequired = false;
  }




  // Check if the current role of the user matches the specified role

  isCurrentRole(item: any, role: string): boolean {
    return (
      this.approvalLevelMap.get(item.current_approval_level_order) === role
    );
  }

  isCeoApprovalSelected(optionKey: string): boolean {
    return this.ceoApprovalType === optionKey;
  }

  onCeoLeaveAdjustmentChange(optionKey: string, checked: boolean): void {
    if (!checked) {
      if (this.ceoApprovalType === optionKey) {
        this.ceoApprovalType = '';
      }
      return;
    }

    this.ceoApprovalType = optionKey;
  }

  private isApprovalCheckedValue(value: any): boolean {
    return value !== null && value !== undefined && value !== '' && value !== 'NA';
  }

  getEmployeeExitDetails(id: any, user: any) {
    // Reset form properties
    this.remark = ''; 
    this.proposedDate = ''; 
    this.leaveAdjustment = ''; 
    this.showRemarkDiv = false; 
    this.isCeo = false;
    this.isFinalHrManager = false;
    this.ceoRemark = '';
    this.ceoApprovalType = 'NA';
    this.hrRemarksFileUrl = '';
    this.hrRemarksUploadError = '';

    // Set the exit form ID and selected user
    this.exitFormId = id;
    this.selectedUser = user;


    // Fetch employee exit details
    this.eSeparationService.employeeExitDetails(id).subscribe(
      (res: any) => {
        console.log(res);
        const {
          exit_reason,
          personal_email,
          whatsapp_no,
          calculated_exit_date,
          approval_type_list,
          proposed_date,
          exit_remarks,
          resignation_date,
          approval_type,
          is_manager,
          is_hr,
          is_ceo,
          ceo_leave_adjustment,
          ceo_remark,
          hr_remark,
        } = res.data;
        this.empData = res.data;
        this.exitReason = exit_reason;
        this.personalEmail = personal_email;
        this.whatsappNo = whatsapp_no;
        this.calculatedExitDate = calculated_exit_date;
        this.resignationDate = resignation_date;
        this.approvalTypes = approval_type_list;
        this.comingProposedDate = proposed_date !== null && proposed_date !== undefined ? proposed_date : calculated_exit_date;
        this.proposedDate = this.comingProposedDate;
        this.remark = exit_remarks;
        this.approvalType = approval_type;
        const ceoELResponse = ceo_leave_adjustment ? String(ceo_leave_adjustment).trim() : '';
        this.ceoApprovalType = ceoELResponse !== '' ? ceoELResponse : 'NA';
        this.ceoRemark = ceo_remark || '';
        this.hrRemark = hr_remark || '';
        this.hrRemarksFileUrl = res?.data?.hr_remarks_file || res?.data?.hr_remark_file || '';
        this.hrRemarksUploadError = '';

        this.isManager = !!is_manager && this.isCurrentRole(this.selectedUser, 'manager');
        this.isHrManager = !!is_hr && this.isCurrentRole(this.selectedUser, 'first_hr_level');
        this.isFinalHrManager = !!is_hr && this.isCurrentRole(this.selectedUser, 'final_hr_level');
        this.isCeo = !!is_ceo && this.isCurrentRole(this.selectedUser, 'ceo');

        this.originalResignationDate = resignation_date;
        this.originalProposedDate = this.comingProposedDate;
        this.mailAttachmentEnabled = false;
        this.mailAttachmentFile = null;
        this.hrRemarkRequired = false;
      },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );
  }

  getSeparationEmpRequestsDetails(id: any) {
    this.eSeparationService.getSeparationEmpRequestsDetails(id).subscribe(
      (res: any) => {
        this.empSeparation = res.data;
        this.getPromotions(id);
      },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );
  }

  getPromotions(id: any) {
    this.eSeparationService.getExitPortalPromotion(id).subscribe(
      (res: any) => {
        this.renderPromotion = true;
        this.promotionData = res.data;
      },
      (error: any) => {
        console.log(error, error.error, error.message);
        if (error.error == "Signature has expired") {
          this.loginService.logout();
        }
      }
    );
  }

  openRemarkPopup(user: any) {
    this.selectedUser = user;
  }

  closeRemarkPopup() {
    this.selectedUser = null;
  }
  // Helper function to get keys of an object
  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  // Handle mail attachment file selection — uploads immediately on file select
  onMailAttachmentChange(event: Event) {
    const input = event.target as HTMLInputElement | null;
    const file = input && input.files && input.files && input.files.length ? input.files[0] : null;
    if (!file) {
      this.mailAttachmentFile = null;
      return;
    }

    this.hrRemarksUploadError = '';
    this.mailAttachmentFile = file;
    this.isUploadingAttachment = true;
    this.eSeparationService.uploadMailAttachment(this.exitFormId, file).subscribe({
      next: (response: any) => {
        this.isUploadingAttachment = false;
        this.mailAttachmentFile = null;
        if (input) {
          input.value = '';
        }
        const uploadedUrl = response?.data?.hr_remarks_file || response?.data?.hr_remark_file || '';
        if (uploadedUrl) {
          this.hrRemarksFileUrl = uploadedUrl;
          this.hrRemarksUploadError = '';
        } else {
          this.hrRemarksUploadError = 'Upload succeeded but file URL was not returned.';
        }
        console.log('Mail attachment uploaded:', response);
      },
      error: (error: any) => {
        this.isUploadingAttachment = false;
        console.error('Mail attachment upload failed:', error);
        this.hrRemarksUploadError = error?.error?.message || 'Failed to upload mail attachment. Please try again.';
        this.mailAttachmentFile = null;
        if (input) { input.value = ''; }
      },
    });
  }

  getFileNameFromUrl(url: string): string {
    if (!url) {
      return '';
    }

    try {
      const cleanUrl = url.split('?')[0];
      const parts = cleanUrl.split('/');
      return decodeURIComponent(parts[parts.length - 1] || 'Uploaded file');
    } catch (_error) {
      return 'Uploaded file';
    }
  }

  openHrRemarksFile(): void {
    if (!this.hrRemarksFileUrl) {
      return;
    }
    window.open(this.hrRemarksFileUrl, '_blank');
  }

  // Helper function to truncate file names for display
  truncateFileName(fileName: string, maxLength: number = 35): string {
    if (!fileName || fileName.length <= maxLength) {
      return fileName;
    }

    const extensionIndex = fileName.lastIndexOf('.');
    const extension = extensionIndex > 0 ? fileName.slice(extensionIndex) : '';
    const nameWithoutExtension = extensionIndex > 0 ? fileName.slice(0, extensionIndex) : fileName;
    const keepLength = Math.max(2, Math.floor((maxLength - extension.length - 2) / 2));
    const firstPart = nameWithoutExtension.slice(0, keepLength);
    const lastPart = nameWithoutExtension.slice(-keepLength);

    return `${firstPart}..${lastPart}${extension}`;
  }

  remainingEL(): string {
    const v = this.empData?.remaining_earned_leave;
    if (v === null || v === undefined) return '0.0';
    if (typeof v === 'number') {
      return (v % 1 === 0) ? v.toFixed(1) : String(v);
    }
    return String(v);
  }

  // Update HR-related states based on changes in resignation or proposed dates
  private updateHrChangeState(): void {
    if (!this.isHrManager) {
      this.hrRemarkRequired = false;
      this.mailAttachmentEnabled = false;
      this.mailAttachmentFile = null;
      this.hrRemarksUploadError = '';
      return;
    }

    const currentResignationDate = this.resignationDate ? String(this.resignationDate).slice(0, 10) : '';
    const currentProposedDate = this.proposedDate ? String(this.proposedDate).slice(0, 10) : '';
    const originalResignationDate = this.originalResignationDate ? String(this.originalResignationDate).slice(0, 10) : '';
    const originalProposedDate = this.originalProposedDate ? String(this.originalProposedDate).slice(0, 10) : '';

    const resignationChanged = !!originalResignationDate && currentResignationDate !== originalResignationDate;
    const proposedChanged = !!originalProposedDate && currentProposedDate !== originalProposedDate;

    this.mailAttachmentEnabled = resignationChanged;
    this.hrRemarkRequired = resignationChanged || proposedChanged;

    if (!resignationChanged) {
      this.mailAttachmentFile = null;
      this.hrRemarksUploadError = '';
    }
  }

}